import {useState} from 'react';
import {EVENTS, Joyride} from 'react-joyride';
import {tourColors, tourStyles} from './tourTheme';

export default function PracticeHint({target, title, content, paused = false}: {
  target: string; title: string; content: string; paused?: boolean;
}) {
  const [hidden, setHidden] = useState(false);
  return <Joyride run={!paused && !hidden} scrollToFirstStep steps={[{target, title, content, placement: 'top'}]}
    floatingOptions={{strategy: 'fixed', autoUpdate: {ancestorScroll: true, elementResize: true, animationFrame: true},
      shiftOptions: {padding: 16}, flipOptions: {padding: 16}}}
    onEvent={event => {if (event.type === EVENTS.TOUR_END) setHidden(true);}}
    options={{skipBeacon: true, buttons: ['close', 'primary'], blockTargetInteraction: false,
      disableFocusTrap: true, hideOverlay: true, closeButtonAction: 'skip', ...tourColors, width: 300, zIndex: 1600}}
    locale={{last: 'Got it', close: 'Hide hint'}}
    styles={tourStyles}/>;
}
